import React from "react";
import {
  gets_skinurl,
  rarity_colors,
  get_primary_color,
  get_accent_color,
} from "./dependencies.jsx";
import { useMySkinsContext } from "./MySkins.jsx";

export const SkinCard = ({ skin }) => {
  const { set_selected_skin } = useMySkinsContext();
  const { infoid, baseskinid, info, rvmode, skins_n, rvsids } = skin;
  const skinImageUrl = gets_skinurl(info.skin, rvmode, info?.is_new);

  const rarity = info?.rarity || "common";
  const rarity_color = rarity_colors[rarity] || rarity_colors.common;
  const primary_color = get_primary_color(info?.skin || baseskinid);
  const accent_color = get_accent_color(info?.skin || baseskinid);
  const skin_name = info?.skin || baseskinid;

  const handle_click = () => {
    set_selected_skin(skin);
  };

  return (
    <div
      onClick={handle_click}
      className="relative rounded-xl overflow-hidden backdrop-blur-md hover:scale-[1.02] transition-all duration-500 group cursor-pointer"
      style={{
        background: `linear-gradient(135deg, ${primary_color}08, ${primary_color}04)`,
        border: `2px solid ${rarity_color}66`,
      }}
    >
      {/* Background Orbs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute top-2 right-8 w-20 h-20 rounded-full blur-xl opacity-40 animate-pulse group-hover:opacity-80 group-hover:scale-150 group-hover:translate-x-16 group-hover:-translate-y-12 group-hover:animate-ping transition-all duration-700"
          style={{ backgroundColor: `${accent_color}30` }}
        />
        <div
          className="absolute bottom-4 left-4 w-16 h-16 rounded-full blur-lg opacity-30 animate-pulse group-hover:opacity-70 group-hover:scale-125 group-hover:-translate-x-12 group-hover:-translate-y-16 group-hover:animate-bounce transition-all duration-500"
          style={{
            backgroundColor: `${primary_color}40`,
            animationDelay: "1s",
          }}
        />
        <div
          className="absolute top-12 left-12 w-12 h-12 rounded-full blur-md opacity-50 animate-pulse group-hover:opacity-90 group-hover:scale-200 group-hover:translate-x-20 group-hover:translate-y-12 group-hover:animate-spin transition-all duration-600"
          style={{
            backgroundColor: `${accent_color}50`,
            animationDelay: "2s",
          }}
        />
      </div>

      {/* Header Row */}
      <div className="flex justify-between items-center p-3">
        {/* Rarity Tag */}
        <div
          className="px-2 py-1 rounded-md text-xs font-bold text-white shadow-sm"
          style={{ backgroundColor: rarity_color }}
        >
          {rarity.toUpperCase()}
        </div>

        {/* RVMode Tag */}
        <div className="px-2 py-1 rounded-md text-xs font-medium bg-slate-700/60 text-white">
          {rvmode.toUpperCase()}
        </div>
      </div>

      {/* Skin Image */}
      <div className="aspect-[1166/656] relative overflow-hidden mx-3 mb-3 rounded-lg">
        {skinImageUrl ? (
          <img
            src={skinImageUrl}
            alt={skin_name}
            className="w-full h-full object-cover group-hover:scale-120 group-hover:opacity-100 transition-all duration-500 shadow-lg mix-blend-multiply opacity-70"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-slate-600/60 to-slate-800/80 flex items-center justify-center">
            <span className="text-gray-400 text-sm font-medium">No Image</span>
          </div>
        )}

        {/* Image Overlay to blend with orbs */}
        <div
          className="absolute inset-0 mix-blend-soft-light opacity-30"
          style={{
            background: `radial-gradient(circle at 80% 20%, ${accent_color}40 20%, transparent 50%), radial-gradient(circle at 20% 80%, ${primary_color}30 15%, transparent 40%)`,
          }}
        />
      </div>

      {/* Skin Name */}
      <div className="px-3 mb-2">
        <h3 className="text-white font-bold text-center text-xl truncate">
          {skin_name}
        </h3>
      </div>

      {/* Owned Copies - Only show if more than 1 */}
      {skins_n > 1 && (
        <div className="px-3 pb-3 flex justify-end">
          <span
            className="text-3xl font-bold italic transform -skew-x-12"
            style={{ color: rarity_color }}
          >
            x{skins_n}
          </span>
        </div>
      )}
    </div>
  );
};
